import React from 'react'

// material ui
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const FinancialAidBanner = props => {
  const { account, session } = props

  // Only show banner if user has an active financial aid approval for current year
  if (!account || !session) {
    return null
  }

  const currentYear = session.year

  const hasActiveApproval = account.financialAidApprovals?.find(
    approval => approval.year === currentYear && approval.status === 'active'
  )

  if (!hasActiveApproval) {
    return null
  }

  const discountAmount = hasActiveApproval.discountCents
  const discountDollars = (discountAmount / 100).toFixed(2)

  return (
    <Box my={3}>
      <Alert severity='success'>
        <Typography variant='body1' fontWeight='fontWeightBold'>
          Financial Aid Approved!
        </Typography>
        <Typography variant='body2'>
          You have been approved for a discount of ${discountDollars} off of each day pass
          for the {currentYear} camp season. This discount will be automatically
          applied to all eligible sessions throughout the year.
        </Typography>
      </Alert>
    </Box>
  )
}

export default FinancialAidBanner
